import Vue from 'vue'
import Vuex from 'vuex'
//import router from '../routes'
//import axios from 'axios'

import app from './app'
import banco from './banco'
import menu from './menu'
import enums from './enums'
import combo from './combo'
import agregado from './agregado'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {      
    app,
    banco,
    menu,
    enums,
    combo,
    agregado
  },

  // state: {
  //   comboSelects: {}
  // },
  // getters: {
  //   getComboSelects (state) {
  //     return state.comboSelects
  //   }
  // },
  // mutations: {
  //   setComboSelects (state, data) {
  //     state.comboSelects = data
  //   }
  // },    
});

/*
export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    errorLogin: false,
    titleScreen:'',
    showLoading: false
  },
  getters: {
    user(state){
      return state.user;
    },
    isAuth(state){
      return state.token !== null;
    },
    getToken(state){
      return state.token;
    },
    getErrorLogin(state){
      return state.errorLogin;
    },
    getTitleScreen(state){
      return state.titleScreen;
    },
    getShowLoading(state){
      return state.showLoading;
    }
  },
  mutations: {
    setUser(state,data){
      state.user = data
    },
    setToken(state,dados){
      state.token = dados
    },
    setLogin(state,data){
      state.token = data.token;
      state.user = data.user;     
    },
    clearLogin(state){
      state.token = null;
      state.user = null;
    },
    setErrorLogin(state,value){
      state.errorLogin=value;
    },
    setTitleScreen(state,title){
      state.titleScreen = title;
    },
    setShowLoading(state,showLoading){
      state.showLoading = showLoading;
    }
  },
  actions: {
    login({commit,dispatch},payload){
       axios.post('/auth/login',{
                login: payload.login,
                password: payload.password
            })
            .then(res => {
                console.log(res);
                if(res && res.status==200 && res.data){
                  console.log(res);
                
                  commit('setLogin',res.data);

                  localStorage.setItem('token',res.data.token);
                  localStorage.setItem('user',res.data.user);

                
                  //dispatch('setLogoutTimer',response.data.expiresIn);                
                  //const now = new Date();
                  //const expirationDate = new Date(now.getTime() + response.data.expiresIn * 1000);
                
                  
                  router.push('/');
                  //localStorage.setItem('expirationDate',expirationDate);
                  //localStorage.setItem('userId',response.data.localId);

                }
            }, error => {
              if (error.response.status === 401) {
                commit('setErrorLogin',true);
              }else{
                erro_geral(error);                
              }
              return error;
            })       
    },
    setLogoutTimer({commit,dispatch},payload){
      // setTimeout(()=>{
      //   dispatch('logout');
      // },payload * 1000 );
    },
   // login({commit,dispatch},authData){

      // instanceAxios.post('accounts:signInWithPassword?key=AIzaSyA6ui65FRUH86ol7b7JoEEf2utnRD6vLF4',{
      //   email:authData.email,
      //   password:authData.password,
      //   returnSecureToken: true
      // })
      // .then(response => {
      //   console.log(response);
      //
      //   commit('authUser',{
      //     token:response.data.idToken,
      //     userId:response.data.localId,
      //   });
      //
      //   dispatch('setLogoutTimer',response.data.expiresIn);
      //
      //   const now = new Date();
      //   const expirationDate = new Date(now.getTime() + response.data.expiresIn * 1000);
      //
      //   localStorage.setItem('token',response.data.idToken);
      //   localStorage.setItem('expirationDate',expirationDate);
      //   localStorage.setItem('userId',response.data.localId);
      //
      // })
      // .catch(error => {
      //   console.log(error);
      // });

    //},
    tryAutoLogin({commit}){
       const token = localStorage.getItem('token');
       //console.log("TOKEN AUTO",token);
       if(!token){
         return;
       }
      
      // const expirationDate = localStorage.getItem('expirationDate');
      // const now = new Date();
      // if(now >= expirationDate ){
      //   return;
      // }
      // console.log(expirationDate);
       const user = localStorage.getItem('user');
       commit('setLogin',{
         token: token,
         user: user
       });
      

    },
    logout({commit}){
       commit('clearLogin');
      
      // localStorage.removeItem('expirationDate');
       localStorage.removeItem('token');
       localStorage.removeItem('user');
      //
       router.replace('/login');
    },
    storeUser({commit,state},userData){
      // if(!state.idToken){
      //   return;
      // }
      //
      // axios.post('users.json'+'?auth='+state.idToken,userData)
      //   .then(res => console.log(res))
      //   .catch( error=> console.log(error))        ;
    },
    fetchUser({commit,state}){
    //
    //   if(!state.idToken){
    //     return;
    //   }
    //
    //   axios.get('/users.json'+'?auth='+state.idToken)
    //     .then( response => {
    //       console.log(response);
    //       const data = response.data;
    //       const users = [];
    //       for(let key in data){
    //         const user = data[key];
    //         user.id = key;
    //         users.push(user);
    //       }
    //
    //       console.log(users);
    //     //  this.email = users[0].email;
    //     commit('storeUser',users[0]);
    //
    //     })
    //     .catch( error => console.log(error));
    //
    }
  }
 
})
*/